<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row" style="margin-top: 10px">
        <div
          class="fuelbalance_first_row_right_section tank__bg"
          style="flex: 0 0 97%; border-radius: 15px"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="our__branches__banner" style="width: 100%; height: 150px">
            <div class="row align-items-center section__row">
              <div class="text-center col-md-12 section___column_1">
                <h4 class="our__branches__banner__title mt-4">
                  <svg
                    class="mr-3"
                    width="58"
                    height="58"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 0C10.751 0 0 10.751 0 24C0 37.249 10.751 48 24 48C37.249 48 48 37.249 48 24C48 10.751 37.249 0 24 0ZM24 1C36.708 1 47 11.292 47 24C47 36.709 36.708 47 24 47C11.292 47 1 36.709 1 24C1 11.292 11.292 1 24 1ZM24.5 12C24.3674 12 24.2402 12.0527 24.1464 12.1464C24.0527 12.2402 24 12.3674 24 12.5V14H23.5C23.3674 14 23.2402 14.0527 23.1464 14.1464C23.0527 14.2402 23 14.3674 23 14.5V16H21V13.506C21 13.3734 20.9473 13.2462 20.8536 13.1524C20.7598 13.0587 20.6326 13.006 20.5 13.006C20.3674 13.006 20.2402 13.0587 20.1464 13.1524C20.0527 13.2462 20 13.3734 20 13.506V16H15V16.025C11.642 16.285 9.033 19.323 9.033 23C9.033 25.541 10.283 27.773 12.16 29H8.506C8.3718 29 8.2431 29.0533 8.1482 29.1482C8.05331 29.2431 8 29.3718 8 29.506V31.496C8 31.776 8.226 32.002 8.506 32.002H11.187L12.049 33.725C12.0907 33.8078 12.1546 33.8773 12.2335 33.9259C12.3125 33.9744 12.4033 34.0001 12.496 34H13.046C13.1634 34.5635 13.4709 35.0694 13.9169 35.4332C14.363 35.7969 14.9204 35.9963 15.496 35.998C16.0717 35.9959 16.6293 35.796 17.0753 35.432C17.5213 35.0679 17.8287 34.5617 17.946 33.998H18.496C18.5887 33.9981 18.6795 33.9724 18.7585 33.9239C18.8374 33.8753 18.9013 33.8058 18.943 33.723L19.805 32H28.195L29.057 33.723C29.0987 33.8058 29.1626 33.8753 29.2415 33.9239C29.3205 33.9724 29.4113 33.9981 29.504 33.998H30.057C30.174 34.5617 30.4811 35.068 30.927 35.4321C31.3729 35.7962 31.9303 35.996 32.506 35.998C33.0818 35.9962 33.6395 35.7966 34.0856 35.4324C34.5317 35.0683 34.839 34.5618 34.956 33.998H35.504C35.5967 33.9981 35.6875 33.9724 35.7665 33.9239C35.8454 33.8753 35.9093 33.8058 35.951 33.723L36.812 32H39.494C39.774 32 40 31.774 40 31.494V29.02H39.494V29H35.84C37.718 27.773 38.967 25.541 38.967 23C38.967 19.154 36.116 16 32.535 16H29V14.5C29 14.3674 28.9473 14.2402 28.8536 14.1464C28.7598 14.0527 28.6326 14 28.5 14H28V12.5C28 12.3674 27.9473 12.2402 27.8536 12.1464C27.7598 12.0527 27.6326 12 27.5 12H24.5ZM25 13H27V14H25V13ZM24 15H28V16H24V15ZM16 17H17V29H16V17ZM18 17H30V29H18V17ZM31 17H32V29H31V17ZM15 17.025V28.975C12.224 28.717 10.033 26.18 10.033 23C10.033 19.82 12.224 17.283 15 17.025ZM33 17.025C35.776 17.283 37.967 19.82 37.967 23C37.967 26.18 35.776 28.717 33 28.975V17.025ZM9.012 30.012H38.988V30.99H9.012V30.012ZM12.307 32.002H13.507C13.287 32.294 13.123 32.629 13.047 33H12.807L12.307 32.002ZM15.477 32.002H15.516C16.341 32.013 16.996 32.672 16.996 33.5C16.996 34.334 16.33 35 15.496 35C14.662 35 13.996 34.334 13.996 33.5C13.996 32.672 14.652 32.012 15.476 32.002H15.477ZM17.484 32.002H18.687L18.187 33H17.945C17.8684 32.6371 17.7112 32.296 17.485 32.002H17.484ZM29.312 32.002H30.518C30.297 32.294 30.132 32.629 30.057 33H29.813L29.312 32.002ZM32.486 32.002H32.526C33.35 32.013 34.006 32.672 34.006 33.5C34.006 34.334 33.34 35 32.506 35C31.672 35 31.006 34.334 31.006 33.5C31.006 32.672 31.661 32.012 32.486 32.002ZM34.494 32.002H35.694L35.194 33H34.955C34.8784 32.6371 34.7202 32.296 34.494 32.002ZM15.496 33C15.3634 33 15.2362 33.0527 15.1424 33.1464C15.0487 33.2402 14.996 33.3674 14.996 33.5C14.996 33.6326 15.0487 33.7598 15.1424 33.8536C15.2362 33.9473 15.3634 34 15.496 34C15.6286 34 15.7558 33.9473 15.8496 33.8536C15.9433 33.7598 15.996 33.6326 15.996 33.5C15.996 33.3674 15.9433 33.2402 15.8496 33.1464C15.7558 33.0527 15.6286 33 15.496 33ZM32.506 33C32.3734 33 32.2462 33.0527 32.1524 33.1464C32.0587 33.2402 32.006 33.3674 32.006 33.5C32.006 33.6326 32.0587 33.7598 32.1524 33.8536C32.2462 33.9473 32.3734 34 32.506 34C32.6386 34 32.7658 33.9473 32.8596 33.8536C32.9533 33.7598 33.006 33.6326 33.006 33.5C33.006 33.3674 32.9533 33.2402 32.8596 33.1464C32.7658 33.0527 32.6386 33 32.506 33Z"
                      fill="white"
                    />
                  </svg>
                  {{ $t("text.iTanks.tanks") }}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="pb-3 mt-3 products_summary__wrapper">
        <div class="row" style="margin-right: 0px">
          <div
            class="text-center col-md-4"
            v-for="(tank, index) in tanks"
            :key="index"
            style="padding-right: 0px !important; margin-bottom: 20px"
          >
            <div class="product_summary__wrapper tank__header__Wrapper">
              <div
                class="product_summary_header tank__header"
                v-bind:style="{ '--vh': tank.waveColor, height: '10px' }"
              ></div>
              <h3 class="mt-3 text-center tank__name">{{ tank.branchName }}</h3>
              <div class="text-center flex___div">
                <small class="time__stamps">
                  <!-- <img
                                                                src="@/assets/img/passage-of-time (1).png"
                                                                width-="18px"
                                                          /> -->
                  {{ tank.name }}
                </small>
                <div class="text-center bowl">
                  <div class="inner">
                    <div
                      class="fill"
                      v-bind:style="{
                        '--h': tank.height + 'px',
                        '--c': tank.waveColor,
                      }"
                    >
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="300px"
                        height="300px"
                        viewBox="0 0 300 300"
                        enable-background="new 0 0 300 300"
                        xml:space="preserve"
                      >
                        <path
                          class="waveShape"
                          d="M300,300V2.5c0,0-0.6-0.1-1.1-0.1c0,0-25.5-2.3-40.5-2.4c-15,0-40.6,2.4-40.6,2.4
                                            c-12.3,1.1-30.3,1.8-31.9,1.9c-2-0.1-19.7-0.8-32-1.9c0,0-25.8-2.3-40.8-2.4c-15,0-40.8,2.4-40.8,2.4c-12.3,1.1-30.4,1.8-32,1.9
                                            c-2-0.1-20-0.8-32.2-1.9c0,0-3.1-0.3-8.1-0.7V300H300z"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix mt-3 volume_info">
                <div class="left_div">
                  <h4 class="vol_sold">{{ $t("text.tanks.productVolume") }}</h4>
                </div>
                <div class="right_div">
                  <h4 class="litres">
                    {{ convertThousand(tank.currentVolume) }} ({{
                      tank.percent
                    }}%)
                  </h4>
                </div>
              </div>
              <div class="clearfix volume_info">
                <div class="left_div">
                  <h4 class="vol_sold">{{ $t("text.tanks.tankCapacity") }}</h4>
                </div>
                <div class="right_div">
                  <h4 class="litres">
                    {{ convertThousand(tank.maxCapacity) }}
                  </h4>
                </div>
              </div>

              <div class="clearfix volume_info">
                <div class="left_div">
                  <h4 class="vol_sold">{{ $t("text.iTanks.waterLevel") }}</h4>
                </div>
                <div class="right_div">
                  <h4 class="vol_sold">
                    {{ convertThousand(tank.waterVolume) }}
                  </h4>
                </div>
              </div>

              <div class="pb-3 mt-3 tanks_probe">
                <div class="mt-4 mb-4">
                  <router-link
                    :to="{
                      name: 'industrialBranchTankProbe',
                      query: {
                        tankId: tank.id,
                        branchId: $route.query.branchId,
                        companyId: $route.query.companyId,
                        groupId: $route.query.groupId,
                      },
                    }"
                    class="btn btn-warning"
                    style="text-decoration: none; padding: 12px 9px"
                    >{{ $t("text.iTanks.probeTransactions") }}</router-link
                  >
                  <router-link
                    :to="{
                      name: 'industrialBranchTankDetails',
                      query: {
                        tankId: tank.id,
                        branchId: $route.query.branchId,
                        companyId: $route.query.companyId,
                        groupId: $route.query.groupId,
                      },
                    }"
                    class="btn btn-success"
                    style="text-decoration: none; padding: 12px 9px"
                    >{{ $t("text.iTanks.dailyReport") }}</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        class="pb-3 products_summary__wrapper"
        v-if="!tanks || (tanks.length < 1 && !showLoader)"
      >
        <div
          class="empty_tank_wrapper"
          style="
            background: white;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-flow: column wrap;
          "
        >
          <div style="margin: 0 auto; width: 50%">
            <div class="legend__div" style="padding-top: 50px">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-3">
                      <div class="row align-items-center">
                        <div class="col-md-3">
                          <div
                            style="
                              height: 10px;
                              width: 30px;
                              background: rgb(216, 153, 28);
                            "
                          ></div>
                        </div>
                        <div class="col-md-6">
                          <div style="display: flex; align-items: center">
                            <div style="color: rgb(216, 153, 28)">
                              {{ countryProducts.products.product1 }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="row align-items-center">
                        <div class="col-md-3">
                          <div
                            style="
                              height: 10px;
                              width: 30px;
                              background: rgb(155, 242, 36);
                            "
                          ></div>
                        </div>
                        <div class="col-md-6">
                          <div style="display: flex; align-items: center">
                            <div style="color: rgb(155, 242, 36)">
                              {{ countryProducts.products.product2 }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="row align-items-center">
                        <div class="col-md-3">
                          <div
                            style="
                              height: 10px;
                              width: 30px;
                              background: rgb(0, 172, 237);
                            "
                          ></div>
                        </div>
                        <div class="col-md-6">
                          <div style="display: flex; align-items: center">
                            <div style="color: rgb(0, 172, 237)">
                              {{ countryProducts.products.product3 }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="row align-items-center">
                        <div class="col-md-3">
                          <div
                            style="
                              height: 10px;
                              width: 30px;
                              background: purple;
                            "
                          ></div>
                        </div>
                        <div class="col-md-6">
                          <div style="display: flex; align-items: center">
                            <div style="color: purple">
                              {{ countryProducts.products.product4 }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center" style="margin-top: 100px">
            <h6 style="color: rgb(161, 146, 146)">No tanks added</h6>
          </div>

          <div class="mt-5 text-center animated__tanks__div">
            <div class="bowl">
              <div class="inner">
                <div class="fill" style="background: grey; height: 0px">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="300px"
                    height
                    viewBox="0 0 300 300"
                    enable-background="new 0 0 300 300"
                    xml:space="preserve"
                  >
                    <path
                      class="waveShape"
                      d="M300,300V2.5c0,0-0.6-0.1-1.1-0.1c0,0-25.5-2.3-40.5-2.4c-15,0-40.6,2.4-40.6,2.4
                                                c-12.3,1.1-30.3,1.8-31.9,1.9c-2-0.1-19.7-0.8-32-1.9c0,0-25.8-2.3-40.8-2.4c-15,0-40.8,2.4-40.8,2.4c-12.3,1.1-30.4,1.8-32,1.9
                                                c-2-0.1-20-0.8-32.2-1.9c0,0-3.1-0.3-8.1-0.7V300H300z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <div class="pb-5 text-cente" style="margin-top: 50px">
            <h3 style="color: rgb(161, 146, 146); font-size: 25px"></h3>
          </div>
        </div>
      </section>
      <TableLoader :showLoader="showLoader" />
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Industrial/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Tankimage.png";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";

export default {
  name: "Tanks",
  components: {
    MasterLayout,
    TableLoader,
  },
  data() {
    return {
      isIncrease: "selectInc",
      ratePercent: null,
      branch: {},
      branchId: null,
      tanks: [],
      backgroundUrl,
      showLoader: true,
      hasLpg: false,
      hasPms: false,
      hasAgo: false,
      hasDpk: false,
      companyId: this.$route.query.companyId,
      productSummary: [],
      pmsSummary: { volume: 0, amount: 0 },
      agoSummary: { volume: 0, amount: 0 },
      dpkSummary: { volume: 0, amount: 0 },
      lpgSummary: { volume: 0, amount: 0 },
      productSummaryCount: 0,
      productCount: "col-lg-3",
      industryBranch: null,
      industryBranchId: null,
    };
  },
  created() {
    this.$eventHub.$on("industryBranch", (industryBranch) => {
      this.industryBranch = industryBranch;
      document.title = `Branch Tanks - ${industryBranch.name}`;
    });
    this.getTanks();
  },
  computed: {
    countryProducts: function () {
      return this.$store.getters.getCountryProducts;
    },
  },
  beforeDestroy() {},

  watch: {
    industryBranch: function (newIndustry, oldIndustry) {
      if (newIndustry.id !== null) {
        this.industryBranchId = newIndustry.id;
        this.getTanks();
      }
    },
  },
  mounted() {},
  methods: {
    checkRate() {
      this.getTanks();
    },

    getTanks() {
      this.showLoader = true;
      let url;

      url = `${configObject.apiBaseUrl}/Branch/Tanks/${
        this.$route.query.branchId
          ? this.$route.query.branchId
          : this.industryBranch.id
      }`;

      this.axios
        .get(url, configObject.authConfig())
        .then((response) => {
          response.data.forEach((element) => {
            element.height = parseInt(
              150 - (element.currentVolume / element.maxCapacity) * 140
            );
            element.nextTwoDaysTankSales = element.nextTwoDaysTankSales
              ? element.nextTwoDaysTankSales
              : 0;
            if (element.height >= 98) {
              element.waveColor = "red";
            } else if (element.height >= 70) {
              element.waveColor = "#039be4";
            } else {
              element.waveColor = "green";
            }
            element.waterVolume =
              element.waterVolume == null ? 0 : element.waterVolume;
            if (
              element.productName !== undefined &&
              element.productName !== null
            ) {
              if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product1
              ) {
                element.color = "#d8991c";
              } else if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product2
              ) {
                element.color = "#0fce29";
              } else if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product3
              ) {
                element.color = "#00aced";
              } else if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product4
              ) {
                element.color = "purple";
              }
            } else if (element.name !== undefined && element.name !== null) {
              if (
                element.name
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product1)
              ) {
                element.color = "#d8991c";
              } else if (
                element.name
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product2)
              ) {
                element.color = "#0fce29";
              } else if (
                element.name
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product3)
              ) {
                element.color = "#00aced";
              } else if (
                element.name
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product4)
              ) {
                element.color = "purple";
              }
            }

            let percent;
            if (
              element.currentVolume <= 0 ||
              element.maxCapacity <= 0 ||
              element.currentVolume == null ||
              element.maxCapacity == null
            ) {
              element.percent = 0;
              element.height = 147;
            } else {
              percent = (element.currentVolume * 100) / element.maxCapacity;
              element.percent = percent.toFixed(1);
              element.height = parseInt(
                150 - (element.currentVolume / element.maxCapacity) * 140
              );
            }
          });

          this.tanks = response.data;
          this.showLoader = false;
          localStorage.setItem("tanks", JSON.stringify(this.tanks));
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getAssociatedPumps(pumps) {
      this.$refs.dataGrid.ej2Instances.setProperties({
        dataSource: response.data,
      });
      this.refreshGrid();
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style scoped>
.pos-card {
  height: 100% !important;
}
.tank-rate h3 {
  font-size: 20px;
  padding-top: 10px;
  text-align: center;
}
.tank-rate {
  background-color: #4c2e73;
  color: white;
  border-radius: 10px;
}

.tank-rate button {
  width: 100%;
  color: black;
  background: white;
  padding: 6px;
  margin-top: 10px;
  margin-bottom: 20px;
  border: none;
  border-radius: 3px;
}

.tank-rate input {
  margin-top: -7px !important;
}

.tank-rate select {
  background: white;
  margin-top: -7px !important;
}
.tank-rate-wrapper {
  width: 90%;
  margin: auto;
}
</style>
